import { openWithTenant } from '@app-store'
import {
  booleanValues,
  Loader,
  Modal,
  SvgCross,
  SvgLeftArrow,
  Tooltip,
  CopyIcon,
  SvgDownload,
  PrintIcon,
  ViewField,
  SvgVerticalSplitter,
  getHtmlDataType,
  communicationStatus,
} from '@ui-kit'
import {
  addToaster,
  hideLoader,
  manualCommunicationDataType,
  mergedInboundWebPdfUrl,
  mergedPdfUrl,
  showLoader,
  useDispatch,
} from '@app-store'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { v4 as uuid } from 'uuid'
import { RootState, useAppSelector } from '../../utils/agent.store'
import {
  ATTACHMENT_FIELD_OPTIONS,
  COMM_TEMPLATE,
  correspondenceLogsPage,
  emailTemplate,
  NAMESPACES,
} from '../../utils/constants'
import {
  formattedCorrespondenceRecipient,
  removeEditableAndRedBackground,
} from '../../utils/helperFunctions'
import { ActionStatusType } from '../../types/correspondenceLogs.types'
import printJS from 'print-js'
import DocumentPopout from '../../components/send-manual-communication/DocumentPopout'
import CommunicationStatus from './CommunicationStatus'

const PreviewCorrespondenceLogs = ({ ...props }) => {
  const manualCommunicationData: manualCommunicationDataType = {
    case_id: '',
    template_name: '',
    mode_of_communication: '',
    program: '',
    service: '',
  }
  const { getValues } = useForm({
    defaultValues: manualCommunicationData,
  })
  const contentRef = useRef<HTMLDivElement | null>(null)
  const htmlType = getHtmlDataType(props?.previewTemplateData?.data?.body)
  //might be used later
  // const pdfPrintRef = useRef<HTMLDivElement | null>(null)
  // const [attachments, setAttachments] = useState<AttachmentDocument[]>([])
  // const [inboundAttachmentName, setInboundAttachmentName] = useState<string>('')
  const [previewUrls, setPreviewUrls] = useState<string>('')
  const [targetURL, setTargetURL] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [to, setTo] = useState('')
  const [cc, setCc] = useState('')
  const [bcc, setBcc] = useState('')
  const [subject, setSubject] = useState('')
  const [letterAddress, setLetterAddress] = useState('')

  const [actionStatus, setActionStatus] = useState<ActionStatusType>({
    copy: true,
    print: false,
    download: false,
  })
  const [actionItem, setActionItem] = useState<string>('')
  const [status, setStatus] = useState<string>(
    props?.previewTemplateData?.status ?? ''
  )
  const selectedTenantId = useAppSelector(
    (state: RootState) => state.authUser.selectedClientTenant?.id
  )
  const dispatch = useDispatch()

  const copyEmailContent = () => {
    if (contentRef?.current) {
      const range = document.createRange()
      const selection = window.getSelection()
      range.selectNodeContents(contentRef?.current)
      selection?.removeAllRanges()
      selection?.addRange(range)
      try {
        // Execute the copy command
        document.execCommand('copy')
        dispatch(
          addToaster({
            message: correspondenceLogsPage.EMAIL_COPY_SUCCESS_MSG,
            type: 'success',
            id: uuid(),
          })
        )
      } catch (error) {
        console.error(error)
        dispatch(
          addToaster({
            message: correspondenceLogsPage.EMAIL_COPY_ERROR_MSG,
            type: 'error',
            id: uuid(),
          })
        )
      }
      // Clear the selection
      selection?.removeAllRanges()
    }
  }

  const printEmailContent = () => {
    const dynamicURL = props?.dynamicURL
    const staticURL = props?.staticURL

    if (typeof dynamicURL === 'string' && dynamicURL.trim() !== '') {
      // case of pdf
      printJS({
        printable: dynamicURL,
        type: 'pdf',
        showModal: true,
      })
    } else if (typeof staticURL === 'string' && staticURL.trim() !== '') {
      // case of image
      printJS({
        printable: staticURL,
        type: 'image',
        showModal: true,
      })
    }
  }

  const printWebEmailContent = () => {
    printJS({
      printable: previewUrls,
      type: 'pdf',
      showModal: true,
    })
  }

  //might be used later
  // const fetchFilePreviewUrl = async (
  //   fileName: Attachment,
  //   showPreviewScreen = true
  // ) => {
  //   try {
  //     dispatch(showLoader())
  //     props?.setDynamicURL('')
  //     props?.setStaticURL('')

  //     const response = await axiosInstance.get(
  //       `${API_END_POINT.CORE}v1/files/generate-download-url?fileName=${fileName?.path}/${fileName?.awsFileName}`,
  //       {
  //         headers: {
  //           'x-tenantid': selectedTenantId,
  //         },
  //       }
  //     )
  //     if (response.data) {
  //       fileName?.attachment_name?.includes('pdf')
  //         ? props?.setDynamicURL(response?.data?.url)
  //         : props?.setStaticURL(response?.data?.url)
  //     }
  //     if (showPreviewScreen) {
  //       setTargetURL(true)
  //       setActionStatus((prev) => {
  //         return { ...prev, copy: false, print: true, download: true }
  //       })
  //     }
  //   } catch (error) {
  //     console.error(CORRESPONDENCE_LOGS_STRINGS.API_ERROR, error)
  //     setTargetURL(false)
  //   } finally {
  //     dispatch(hideLoader())
  //   }
  // }

  // const handleViewClick = async (
  //   file: Attachment,
  //   showPreviewScreen = true
  // ) => {
  //   await fetchFilePreviewUrl(file, showPreviewScreen)
  // }
  // const handleChange = (
  //   item: Attachment,
  //   showPreviewScreen = true,
  //   actionItem?: string
  // ) => {
  //   if (actionItem) setActionItem(actionItem)
  //   if (props?.uniqueKey === correspondenceLogsPage.INBOUND_LOWERCASE) {
  //     const getInboundFaxPdf = async () => {
  //       try {
  //         if (
  //           props?.openPreviewModal?.type === emailTemplate.FAX &&
  //           props?.uniqueKey === correspondenceLogsPage.INBOUND_LOWERCASE
  //         ) {
  //           dispatch(showLoader())
  //           props?.setDynamicURL('')
  //           props?.setStaticURL('')
  //           const response = await fetchFaxUrl(
  //             props?.previewTemplateData?.communicationId
  //           )
  //           props?.setDynamicURL(response?.data?.url ?? '')
  //           if (showPreviewScreen) {
  //             setTargetURL(true)
  //             setActionStatus((prev) => {
  //               return { ...prev, copy: false, print: true, download: true }
  //             })
  //           }
  //         }
  //       } catch (error) {
  //         console.error(CORRESPONDENCE_LOGS_STRINGS.API_ERROR, error)
  //       } finally {
  //         dispatch(hideLoader())
  //       }
  //     }
  //     getInboundFaxPdf()
  //   } else {
  //     handleViewClick(item, showPreviewScreen)
  //   }
  // }

  const handleLeftArrowClick = () => {
    setTargetURL(false)
    props?.setStaticURL('')
    props?.setDynamicURL('')
    setActionStatus((prev) => {
      return { ...prev, copy: true, print: false, download: false }
    })
  }

  const downloadFile = async (url: string) => {
    try {
      const fileName = url.split('/').pop()?.split('?')[0] || 'document.pdf'

      const response = await fetch(url)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const blob = await response.blob()
      const blobUrl = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', fileName)
      link.style.display = 'none'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error('Download failed:', error)
      openWithTenant(url, '_blank')
    }
  }

  // const transformToAttachment = (data: AttachmentDocument[]) => {
  //   return data?.map((item) => ({
  //     attachment_name: item.alias ?? '',
  //     attachment_document_id: item?.exp ?? 0,
  //     attachment_type: item.extension ?? '',
  //     attachment_url: item.name ?? '',
  //     attachment_document_type: item.extension ?? '',
  //     awsFileName: item?.name ?? '',
  //     attachment_data: item.name ?? '',
  //     contains_docusign: item?.metaData?.isDocusign ?? false,
  //     id: item.name?.toString() ?? '',
  //     path: item?.path ?? '',
  //   }))
  // }

  const isCKEditorContent = (): boolean => {
    return (
      props?.previewTemplateData?.data?.body &&
      htmlType !== 'base64-pdf' &&
      props?.previewTemplateData?.type !== emailTemplate.FAX &&
      props?.previewTemplateData?.type !== emailTemplate.LETTER &&
      props?.previewTemplateData?.type !== emailTemplate.POSTALMAIL
    )
  }

  const getAutoPopulatedFields = () => {
    if (isLoading) {
      return <Loader loaderHeight="100" loaderWidth="100" isGlobal={false} />
    } else if (!targetURL) {
      return (
        <div className="flex flex-col flex-1 min-h-0 overflow-hidden h-full">
          {props?.openPreviewModal?.type === emailTemplate.EMAIL && (
            <div className="flex flex-col gap-6 w-full shrink-0">
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 relative">
                  <Tooltip
                    content={getValues('to') ?? ''}
                    className="text-wrap w-[14.75rem] z-50"
                    position="bottom"
                    cssClassName={'z-50'}
                  >
                    {to && (
                      <ViewField
                        label={emailTemplate.To}
                        data={to}
                        colSpan={1}
                      />
                    )}
                  </Tooltip>
                </div>
                <div className="col-span-1 relative">
                  <Tooltip
                    content={getValues('cc') ?? ''}
                    className="text-wrap w-[14.75rem] z-50"
                    position="bottom"
                    cssClassName={'z-50'}
                  >
                    {cc && (
                      <ViewField
                        label={emailTemplate.Cc}
                        data={cc}
                        colSpan={1}
                      />
                    )}
                  </Tooltip>
                </div>
                <div className="col-span-1 relative">
                  <Tooltip
                    content={getValues('bcc') ?? ''}
                    className="text-wrap w-[14.75rem] z-50"
                    position="bottom"
                    cssClassName={'z-50'}
                  >
                    {bcc && (
                      <ViewField
                        label={emailTemplate.Bcc}
                        data={bcc}
                        colSpan={1}
                      />
                    )}
                  </Tooltip>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-3">
                  {subject && (
                    <ViewField
                      label={emailTemplate.Subject}
                      data={subject}
                      colSpan={1}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {props?.openPreviewModal?.type === emailTemplate.LETTER &&
            props?.uniqueKey !== correspondenceLogsPage.OUTBOUND_LOWERCASE && (
              <div className="flex flex-col gap-6 w-full shrink-0">
                <div className="grid grid-cols-3 gap-4">
                  <div className="col-span-3 relative">
                    <Tooltip
                      content={getValues('letter_address') ?? ''}
                      className="text-wrap w-[14.75rem] z-50"
                      position="bottom"
                      cssClassName={'z-50'}
                    >
                      <ViewField
                        label={COMM_TEMPLATE.RECIPIENT_NAME}
                        data={letterAddress}
                        colSpan={1}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            )}
          {props?.openPreviewModal?.type === emailTemplate.SMS && (
            <div className="flex flex-col gap-6">
              <div className="grid grid-cols-4 gap-4">
                <div className="col-span-2 relative">
                  <Tooltip
                    content={getValues('to') ?? ''}
                    className="text-wrap w-[14.75rem] z-50"
                    position="bottom"
                    cssClassName={'z-50'}
                  >
                    {to && (
                      <ViewField
                        label={COMM_TEMPLATE.SMS_RECIPIENTS}
                        data={to}
                        colSpan={1}
                      />
                    )}
                  </Tooltip>
                </div>
              </div>
            </div>
          )}
          {(props?.openPreviewModal?.type === emailTemplate.FAX ||
            props?.openPreviewModal?.type === emailTemplate.LETTER) &&
            props?.uniqueKey === correspondenceLogsPage.OUTBOUND_LOWERCASE && (
              <div className="flex flex-col gap-6">
                <div className="grid grid-cols-4 gap-4">
                  <div className="col-span-2 relative">
                    <Tooltip
                      content={getValues('to') ?? ''}
                      className="text-wrap w-[14.75rem] z-50"
                      position="bottom"
                      cssClassName={'z-50'}
                    >
                      {to && (
                        <ViewField
                          label={
                            props?.openPreviewModal?.type ===
                            emailTemplate.LETTER
                              ? COMM_TEMPLATE.RECIPIENT_LETTER_ADDRESS
                              : COMM_TEMPLATE.RECIPIENT_FAX_NUMBER
                          }
                          data={to}
                          colSpan={1}
                        />
                      )}
                    </Tooltip>
                  </div>
                </div>
              </div>
            )}
          {props?.openPreviewModal?.type === emailTemplate.WEB && (
            <div className="flex flex-col gap-6">
              <div className="grid grid-cols-4 gap-4">
                <div className="col-span-2 relative">
                  <span className=" font-primary text-xs">Received From: </span>
                  <span className="font-light text-xs">
                    {props?.previewTemplateData?.row?.received_from}
                  </span>
                </div>
              </div>
            </div>
          )}
          {/* document preview */}
          <div
            className={`p-2 border border-border-100 mt-3 rounded-[0.3rem] flex-1 basis-0 min-h-[6.25rem] ${
              isCKEditorContent() ? 'overflow-y-auto' : ''
            }`}
          >
            {/*might be used later */}
            {/* attachments */}
            {/* {attachments?.length !== 0 &&
              props?.previewTemplateData?.data?.body && (
                <div className="rounded-[0.25rem] mb-6">
                  <div className="w-full">
                    <AttachmentField
                      showPreview={true}
                      handlePreviewClick={handleChange}
                      showPrint={true}
                      showDownload={true}
                      showMoreOptions={true}
                      inboundAttachmentName={inboundAttachmentName + '.pdf'}
                      onAttachmentClick={handleChange}
                      data={transformToAttachment(attachments)}
                      label=""
                    />
                  </div>
                </div>
              )} */}
            {
              isLoading ? (
                <Loader loaderHeight="100" loaderWidth="100" isGlobal={false} />
              ) : // commented for now, will remove later
              // props?.openPreviewModal?.type !== emailTemplate.LETTER &&
              //   props?.openPreviewModal?.type !== emailTemplate.FAX ?
              isCKEditorContent() ? (
                <>
                  <div
                    ref={contentRef}
                    dangerouslySetInnerHTML={{
                      __html: removeEditableAndRedBackground(
                        props?.previewTemplateData?.data?.body
                      ),
                    }}
                    className="bg-inherit overflow-x-auto font-primary ck-content p-1"
                    style={{
                      lineHeight: '1rem',
                      borderRadius: '0.5rem',
                      fontSize: '0.875rem',
                    }}
                  />
                  {previewUrls && (
                    <div className="p-3 border border-border-100 mt-3 rounded-[0.3rem] overflow-y-auto preview-box w-full overflow-x-auto">
                      <iframe
                        title={`file preview`}
                        src={`${previewUrls}#toolbar=0&navpanes=0`}
                        height="540"
                        className="w-[100%]"
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  {previewUrls ? (
                    <div className="p-3 border border-border-100 mt-3 rounded-[0.3rem] overflow-y-auto preview-box w-full overflow-x-auto">
                      <iframe
                        title={`file preview`}
                        src={`${previewUrls}#toolbar=0&navpanes=0`}
                        height="540"
                        className="w-[100%]"
                      />
                    </div>
                  ) : (
                    <p>No document attached.</p>
                  )}
                </>
              )

              // commented for now, will remove later
              // : (
              //   <div className="p-3 mt-3 rounded-[0.3rem]">
              //     <PdfViewer
              //       pdfUrl={props?.previewTemplateData?.data?.body}
              //     />
              //   </div>
              // )
            }
          </div>
        </div>
      )
    }
  }

  const loadPreviews = useCallback(async () => {
    let url = null

    try {
      dispatch(showLoader())

      if (props?.uniqueKey !== correspondenceLogsPage.INBOUND_SMS_LOWERCASE) {
        if (props?.uniqueKey !== correspondenceLogsPage.INBOUND_WEB_KEY) {
          const id = props?.previewTemplateData?.data?.id
          const response = await mergedPdfUrl(id)

          if (response?.data) {
            url = response?.data?.attachment[0]?.url
            setPreviewUrls(url)
          }
        } else {
          const response = await mergedInboundWebPdfUrl(
            props?.previewTemplateData?.communicationId
          )

          if (response?.data) {
            url = response?.data?.attachment[0]?.url
            setPreviewUrls(url)
          }
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }

    return url
  }, [selectedTenantId, dispatch])

  useEffect(() => {
    loadPreviews()
  }, [selectedTenantId])

  useEffect(() => {
    if (props?.previewTemplateData?.data) {
      const data = props?.previewTemplateData?.data

      if (data?.correspondenceType === COMM_TEMPLATE?.EMAIL_UPPERCASE) {
        setTo(data?.recipientsTo?.join(', ') ?? '')
        setCc(data?.recipientsCc?.join(', ') ?? '')
        setBcc(data?.recipientsBcc?.join(', ') ?? '')
        setSubject(data?.subject ?? '')
      } else if (
        data?.correspondenceType === COMM_TEMPLATE?.LETTER_UPPERCASE &&
        props?.uniqueKey === correspondenceLogsPage.OUTBOUND_LOWERCASE
      ) {
        setTo(
          formattedCorrespondenceRecipient(
            'to',
            data?.viewObject ?? [],
            COMM_TEMPLATE.LETTER_CAPITAL
          )?.join(', ') || ''
        )
      } else if (
        data?.correspondenceType === COMM_TEMPLATE?.LETTER_UPPERCASE &&
        props?.uniqueKey !== correspondenceLogsPage.OUTBOUND_LOWERCASE
      ) {
        setLetterAddress(data?.recipientsTo?.join(', ') ?? '')
      } else if (
        data?.correspondenceType === COMM_TEMPLATE.FAX_UPPERCASE ||
        data?.correspondenceType === COMM_TEMPLATE?.SMS_UPPERCASE
      ) {
        setTo(
          formattedCorrespondenceRecipient('to', data?.viewObject ?? [])?.join(
            ', '
          ) || ''
        )
      }
    }

    // setAttachments(props?.previewTemplateData?.documentEntities ?? [])
    // setInboundAttachmentName(props?.previewTemplateData?.faxName ?? '')
    setIsLoading(false)
  }, [props?.previewTemplateData?.data])
  useEffect(() => {
    if (props?.staticURL || props?.dynamicURL) {
      if (actionItem === ATTACHMENT_FIELD_OPTIONS.PRINT) {
        printEmailContent()
        setActionItem('')
      } else if (actionItem === ATTACHMENT_FIELD_OPTIONS.DOWNLOAD) {
        props?.downloadEmailContent()
        setActionItem('')
      }
    }
  }, [props?.dynamicURL, props?.staticURL])
  return (
    <div className="a4modal">
      <Modal
        isOpen={props?.openPreviewModal?.value}
        closeModal={() => {
          props.handlePreviewClose(booleanValues.FALSE, '')
          setTargetURL(false)
        }}
        showCloseButton={false}
        className="z-10"
        cssClassName="z-10"
        closeModalOnOutsideClick={false}
        isDragable
        isBackdropInteractive
        isResizable
        width="w-[min(55.5rem,calc(100vw-2rem))] max-w-[55.5rem]"
        bodyCssClassName="!flex !flex-col !overflow-hidden [&_.modal-scroll-container]:!flex-1 [&_.modal-scroll-container]:!min-h-0 [&_.modal-scroll-container]:!overflow-hidden [&_.modal-body-container]:!h-full [&_.modal-body-container]:!min-h-0"
        minResizeWidth={480}
        minResizeHeight={300}
      >
        <form className="w-[55.5rem] max-w-full min-w-0 h-[35rem] max-h-full min-h-[calc(9rem+6.25rem)] flex flex-col overflow-hidden">
          <div className="flex flex-col w-full h-full min-h-0 overflow-hidden">
            <div className="flex justify-between items-center gap-2 mb-4 w-full shrink-0">
              {/* heading */}
              <div className="font-medium text-sm shrink-0 whitespace-nowrap">
                <div className="headingContent flex flex-row items-center gap-4">
                  {targetURL && (
                    <div
                      className="cursor-pointer shrink-0"
                      onClick={handleLeftArrowClick}
                    >
                      <SvgLeftArrow />
                    </div>
                  )}
                  <div className="text-base font-primary font-medium whitespace-nowrap">
                    {props?.openPreviewModal?.type === emailTemplate.EMAIL &&
                      emailTemplate.Email_Preview}
                    {props?.openPreviewModal?.type === emailTemplate.FAX &&
                      emailTemplate.Fax_Preview}
                    {props?.openPreviewModal?.type === emailTemplate.LETTER &&
                      emailTemplate.Letter_Preview}
                    {props?.openPreviewModal?.type === emailTemplate.SMS &&
                      emailTemplate.Sms_Preview}
                    {props?.openPreviewModal?.type === emailTemplate.WEB &&
                      emailTemplate.WEB_ENROLLMENT_PREVIEW}
                    {props?.openPreviewModal?.type ===
                      emailTemplate.POSTALMAIL && emailTemplate.MAIL_PREVIEW}
                  </div>
                </div>
              </div>
              <div className="flex gap-4 items-center shrink-0 whitespace-nowrap">
                {/* Status Column */}
                <div className="flex items-center justify-end gap-2 shrink-0">
                  <span>{NAMESPACES.STATUS_LABEL} :</span>
                  <div className="flex p-1">
                    <CommunicationStatus
                      approved={status}
                      tableType={props?.tableType}
                      recordId={props?.previewTemplateData?.recordId}
                      setRefetchKey={props?.setRefetchKey}
                      onChange={() => setStatus(communicationStatus.RECIEVED)}
                      key={status}
                    />
                  </div>
                </div>

                {(props?.openPreviewModal?.type === emailTemplate.EMAIL ||
                  props?.openPreviewModal?.type === emailTemplate.SMS) &&
                  actionStatus?.copy && (
                    <div
                      className="flex items-center justify-center h-5 w-5 cursor-pointer shrink-0"
                      onClick={copyEmailContent}
                    >
                      <CopyIcon />
                    </div>
                  )}
                {
                  <>
                    {actionStatus?.print && (
                      <div
                        onClick={printEmailContent}
                        className="cursor-pointer shrink-0"
                      >
                        <PrintIcon height={'1.5rem'} width={'1.5rem'} />
                      </div>
                    )}
                    {actionStatus?.download && (
                      <div
                        onClick={props?.downloadEmailContent}
                        className="cursor-pointer shrink-0"
                      >
                        <SvgDownload height={'1.5rem'} width={'1.5rem'} />
                      </div>
                    )}
                  </>
                }
                {previewUrls &&
                  !actionStatus?.print &&
                  !actionStatus?.download &&
                  actionStatus?.copy && (
                    <>
                      <div className="shrink-0">
                        <PrintIcon
                          onClick={printWebEmailContent}
                          className="cursor-pointer"
                        />
                      </div>
                      <div
                        className="cursor-pointer shrink-0"
                        onClick={async () => {
                          if (previewUrls && previewUrls !== 'error') {
                            await downloadFile(previewUrls)
                          }
                        }}
                      >
                        <SvgDownload />
                      </div>
                      <div className="flex items-center justify-center shrink-0">
                        <SvgVerticalSplitter height={'1rem'} />
                      </div>
                      <DocumentPopout
                        source={
                          props?.dynamicURL || props?.staticURL || previewUrls
                        }
                        generateUrl={loadPreviews}
                      />
                    </>
                  )}
                <div
                  className="flex items-center justify-center h-4 w-4 cursor-pointer shrink-0"
                  onClick={() => {
                    props.handlePreviewClose(booleanValues.FALSE, '')
                    setTargetURL(false)
                  }}
                >
                  <SvgCross height={'14px'} width={'14px'} />
                </div>
              </div>
              {/* auto populate fields */}
            </div>
            <div className="flex-1 min-h-0 overflow-hidden flex flex-col">
              {getAutoPopulatedFields()}
            </div>
          </div>
        </form>
      </Modal>
    </div>
  )
}

export default PreviewCorrespondenceLogs
